import React, {useState} from 'react';
import {IonIcon, IonInput, IonItem, IonLabel} from "@ionic/react";
import {eye, eyeOff} from "ionicons/icons";

interface PasswordInputProps {
  label?: string;
  value?: string;
  onChange: (value: string) => void;
}

const PasswordInput: React.FC<PasswordInputProps> = (props) => {
  const {value, onChange, label} = props;
  const [inputType, setInputType] = useState<'password'|'text'>('password');
  const [inputIcon, setInputIcon] = useState(eyeOff);

  const onToggle = () => {
    if (inputType === 'password') {
      setInputType('text');
      setInputIcon(eye);
    } else {
      setInputType('password');
      setInputIcon(eyeOff);
    }
  }

  return (
    <IonItem>
      <IonLabel position="floating">
        {label || 'Senha'}
      </IonLabel>
      <div className="flex gap-4 w-full">
        <IonInput
          type={inputType}
          onIonChange={(e) => onChange(e.detail.value!)}
          value={value}
        />
        <div
          className="cursor-pointer"
          onClick={onToggle}
        >
          <IonIcon
            icon={inputIcon}
            className="text-xl"
          />
        </div>
      </div>
    </IonItem>
  );
}

export default PasswordInput;
